import { TooltipWrapper } from '@va/ui/tooltips';
import classNames from 'classnames';

export const FormElement = ({ label, input: Input, name, additionalCss, errorMsg, infoTooltip, ...props }: any) => {
  return (
    <div className='flex flex-column w-full'>
      <div className={classNames('lg:flex items-center', additionalCss)}>
        <label htmlFor={name} className={classNames('font-bold block lg:min-w-1/3 lg:w-1/3 py-2 pr-2')} title={label}>
          <TooltipWrapper interactive disabled={!infoTooltip} content={infoTooltip}>
            <span className={classNames({ 'underline-dashed': infoTooltip })}>{label}:</span>
          </TooltipWrapper>
        </label>

        <Input name={name} {...props} className='grow' />
      </div>
      {errorMsg && <div className='mt-2 text-sm text-red-negative lg:ml-33-percent'>{errorMsg}</div>}
    </div>
  );
};
